module.exports = __webpack_public_path__ + "static/media/cloud-info.2a9d7f7d.svg";